// Define a type for the country code pricing
interface CountryCodePricing {
  price: number;
  country: string;
}

// Define the phone number pricing map type
type PhoneNumberPricing = {
  [phonePrefix: string]: CountryCodePricing;
};

// The actual pricing data
export const phoneNumberPrices: PhoneNumberPricing = {
  "+376": { price: 0.045, country: "AD" },
  "+355": { price: 0.2, country: "AL" },
  "+374": { price: 0.2, country: "AM" },
  "+43": { price: 0.2, country: "AT" },
  "+994": { price: 0.18, country: "AZ" },
  "+387": { price: 0.17, country: "BA" },
  "+32": { price: 0.21, country: "BE" },
  "+359": { price: 0.2, country: "BG" },
  "+375": { price: 0.2, country: "BY" },
  "+41": { price: 0.077, country: "CH" },
  "+357": { price: 0.19, country: "CY" },
  "+420": { price: 0.21, country: "CZ" },
  "+49": { price: 0.19, country: "DE" },
  "+45": { price: 0.25, country: "DK" },
  "+372": { price: 0.2, country: "EE" },
  "+34": { price: 0.21, country: "ES" },
  "+358": { price: 0.24, country: "FI" },
  "+33": { price: 0.2, country: "FR" },
  "+44": { price: 0.2, country: "GB" },
  "+995": { price: 0.18, country: "GE" },
  "+30": { price: 0.24, country: "GR" },
  "+385": { price: 0.25, country: "HR" },
  "+36": { price: 0.27, country: "HU" },
  "+353": { price: 0.23, country: "IE" },
  "+354": { price: 0.24, country: "IS" },
  "+39": { price: 0.22, country: "IT" },
  "+423": { price: 0.077, country: "LI" },
  "+370": { price: 0.21, country: "LT" },
  "+352": { price: 0.16, country: "LU" },
  "+371": { price: 0.21, country: "LV" },
  "+373": { price: 0.2, country: "MD" },
  "+377": { price: 0.2, country: "MC" },
  "+382": { price: 0.21, country: "ME" },
  "+389": { price: 0.18, country: "MK" },
  "+47": { price: 0.25, country: "NO" },
  "+48": { price: 0.23, country: "PL" },
  "+351": { price: 0.23, country: "PT" },
  "+40": { price: 0.19, country: "RO" },
  "+381": { price: 0.2, country: "RS" },
  "+7": { price: 0.2, country: "RU" },
  "+421": { price: 0.2, country: "SK" },
  "+386": { price: 0.22, country: "SI" },
  "+46": { price: 0.25, country: "SE" },
  "+90": { price: 0.18, country: "TR" },
  "+380": { price: 0.2, country: "UA" },
  "+379": { price: 0.0, country: "VA" },
  "+383": { price: 0.18, country: "XK" },
};

const sortedPrefixes = Object.keys(phoneNumberPrices).sort((a, b) => b.length - a.length);

// Helper function to get pricing for a phone number
export function getVatFromPhoneNumber(phoneNumber: string): number | undefined {
  // Find the first matching prefix
  const matchedPrefix = sortedPrefixes.find((prefix) => phoneNumber.startsWith(prefix));

  // Return the pricing if a match is found
  return matchedPrefix ? phoneNumberPrices[matchedPrefix].price : undefined;
}

export function getCountryFromPhoneNumber(phoneNumber: string): string | undefined {
  // Find the first matching prefix
  const matchedPrefix = sortedPrefixes.find((prefix) => phoneNumber.startsWith(prefix));

  // Return the country if a match is found
  return matchedPrefix ? phoneNumberPrices[matchedPrefix].country : undefined;
}
